import { Image } from 'expo-image';
import { Text, View, YStack } from 'tamagui';

const WIDTH = 240;
// Portrait 3:4 poster, same ratio as EventCard.
const HEIGHT = WIDTH * (4 / 3);

export default function ShowcaseEventCard({
  eventId,
  title,
  imageUrl,
  onPress,
}: {
  eventId: string;
  title: string;
  imageUrl?: string;
  onPress: (eventId: string) => void;
}) {
  return (
    <YStack width={WIDTH} onPress={() => onPress(eventId)}>
      <View
        width={WIDTH}
        height={HEIGHT}
        borderTopLeftRadius="$base"
        borderTopRightRadius="$base"
        overflow="hidden"
      >
        <Image
          source={{ uri: imageUrl }}
          style={{ width: WIDTH, height: HEIGHT }}
          contentFit="cover"
          transition={200}
        />
      </View>
      <YStack
        // Fills the height a stretched row hands the card, so panels in a row
        // end on the same line however many lines their titles take.
        flexGrow={1}
        backgroundColor="$color.brand"
        borderBottomLeftRadius="$base"
        borderBottomRightRadius="$base"
        p="$md"
        pb="$lg"
      >
        <Text
          fontFamily="$body"
          fontSize="$base"
          fontWeight="$semibold"
          numberOfLines={2}
          color="$textWhite"
        >
          {title}
        </Text>
      </YStack>
    </YStack>
  );
}
